const _label = { 
    vnTitle : 'Select virtual number',
    vnPlaceholder: 'Select a virtual number ',
    emptySmsTemplate: 'No sms template created yet'
}
export default _label;